// extracted by mini-css-extract-plugin
module.exports = {"timePeriodList":"styles__timePeriodList___3H7jb","timePeriodItem":"styles__timePeriodItem___1Vj57","timePeriodLabel":"styles__timePeriodLabel___1Ty4l"};